const routes = [
  {
    path: "/",
    component: () => import("src/layouts/LayoutAuth.vue"),
    children: [
      { path: "", component: () => import("src/pages/auth/PageIndex.vue") },
      {
        path: "/login",
        component: () => import("src/pages/auth/PageLogin.vue"),
      },
      {
        path: "/login/:email",
        component: () => import("src/pages/auth/PageLogin.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("src/layouts/LayoutMotorista.vue"),
    children: [
      {
        path: "/motorista",
        component: () => import("src/pages/motorista/PageMotorista.vue"),
      },
      {
        path: "/ocorrencia",
        component: () => import("src/pages/motorista/PageOcorrencia.vue"),
      },
      {
        path: "/editar-minha-conta",
        component: () => import("src/pages/motorista/PageEditarMinhaConta.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("src/layouts/LayoutMain.vue"),
    children: [
      { path: "/painel", redirect: "/visao-geral" }, // TODO remove
      {
        path: "/welcome",
        component: () => import("src/pages/main/PageWelcome.vue"),
      },
      {
        path: "/visao-geral",
        component: () => import("src/pages/main/PageVisaoGeral.vue"),
      },

      {
        path: "/monitoramento",
        component: () => import("src/pages/main/PageMonitoramento.vue"),
      },
      {
        path: "/trajetos",
        component: () => import("src/pages/main/PageTrajetos.vue"),
      },
      // {
      //   path: "/ultimo-trajeto/:deviceId",
      //   component: () => import("src/pages/main/PageUltimoTrajeto.vue"),
      // },

      {
        path: "/cargas",
        component: () => import("src/pages/main/PageCargas.vue"),
      },

      {
        path: "/notas-fiscais",
        component: () => import("src/pages/main/PageNotasFiscais.vue"),
      },
      {
        path: "/notas-fiscais-manejo",
        component: () => import("src/pages/main/PageManejoDeNotasFiscais.vue"),
      },

      {
        path: "/viagens",
        component: () => import("src/pages/main/PageViagens.vue"),
      },
      {
        path: "/viagens/:dti/:dtf/:viagem_status/:pedido_status/:veiculo_id/:motorista_id",
        component: () => import("src/pages/main/PageViagens.vue"),
      },
      {
        path: "/viagens/:dti/:dtf/:viagem_status/:pedido_status/:veiculo_id/:motorista_id/:search",
        component: () => import("src/pages/main/PageViagens.vue"),
      },

      {
        path: "/emissores",
        component: () => import("src/pages/main/PageEmissoresIndustrias.vue"),
      },

      {
        path: "/clientes",
        component: () => import("src/pages/main/PageClientes.vue"),
      },
      {
        path: "/clientes/:search",
        component: () => import("src/pages/main/PageClientes.vue"),
      },

      {
        path: "/empresas",
        component: () => import("src/pages/main/PageEmpresas.vue"),
      },
      {
        path: "/veiculos",
        component: () => import("src/pages/main/PageVeiculos.vue"),
      },
      {
        path: "/veiculos/:search",
        component: () => import("src/pages/main/PageVeiculos.vue"),
      },

      {
        path: "/motivos",
        component: () => import("src/pages/main/PageMotivosDeDevolucao.vue"),
      },
      {
        path: "/motivos/:search",
        component: () => import("src/pages/main/PageMotivosDeDevolucao.vue"),
      },

      {
        path: "/itens",
        component: () => import("src/pages/main/PageItensdeChecagem.vue"),
      },
      {
        path: "/usuarios",
        component: () => import("src/pages/main/PageUsuarios.vue"),
      },
      {
        path: "/checagens",
        component: () => import("src/pages/main/PageChecagens.vue"),
      },

      {
        path: "/ocorrencias",
        component: () => import("src/pages/main/PageOcorrencias.vue"),
      },
      {
        path: "/ocorrencias/:dti/:dtf/:veiculo_id/:motorista_id",
        component: () => import("src/pages/main/PageOcorrencias.vue"),
      },
      {
        path: "/sobre",
        component: () => import("src/pages/main/PageSobre.vue"),
      },
      {
        path: "/configuracoes",
        component: () => import("src/pages/main/PageConfiguracoes.vue"),
      },

      {
        path: "/centros-de-distribuicao",
        component: () => import("src/pages/main/PageCentrosDeDistribuicao.vue"),
      },
      {
        path: "/centros-de-distribuicao/:search",
        component: () => import("src/pages/main/PageCentrosDeDistribuicao.vue"),
      },

      {
        path: "/inspecoes",
        component: () => import("src/pages/main/PageInspecoes.vue")
      },

      {
        path: "/permissoes",
        component: () => import("src/pages/main/PagePermissoes.vue")
      },
      {
        path: "/permissoes/:search",
        component: () => import("src/pages/main/PagePermissoes.vue"),
      },

      {
        path: "/romaneios",
        component: () => import("src/pages/main/PageRomaneios.vue")
      },
      {
        path: "/romaneios/:search",
        component: () => import("src/pages/main/PageRomaneios.vue"),
      },

      {
        path: "/series",
        component: () => import("src/pages/main/PageSeries.vue")
      },
    ],
  },
];

routes.push({
  path: "*",
  component: () => import("src/pages/Page404.vue"),
});

export default routes;
